import { ref } from "vue";
import { defineStore } from "pinia";

export const usePermission = defineStore("permission", () => {
  const routePermissions = ref([
    {
      action: "dashboard",
      subject: ["administrator", "staff"],
    },
    {
      action: "calendar",
      subject: ["administrator", "staff"],
    },
    {
      action: "appointment.list",
      subject: ["administrator", "staff"],
    },
    {
      action: "appointment.add",
      subject: ["administrator", "staff"],
    },
    {
      action: "appointment.edit",
      subject: ["administrator", "staff"],
    },
    {
      action: "service.list",
      subject: ["administrator", "staff"],
    },
    {
      action: "service.add",
      subject: ["administrator"],
    },
    {
      action: "service.edit",
      subject: ["administrator"],
    },
    {
      action: "staff.list",
      subject: ["administrator", "staff"],
    },
    {
      action: "staff.invite",
      subject: ["administrator"],
    },
    {
      action: "staff.add",
      subject: ["administrator"],
    },
    {
      action: "staff.edit",
      subject: ["administrator"],
    },
    {
      action: "staff.view",
      subject: ["administrator", "staff"],
    },
    {
      action: "staff.provider",
      subject: ["administrator"],
    },
    {
      action: "settings",
      subject: ["administrator"],
    },
    {
      action: "settings.general",
      subject: ["administrator"],
    },
    {
      action: "settings.business",
      subject: ["administrator"],
    },
    {
      action: "settings.provider",
      subject: ["administrator"],
    },
    {
      action: "settings.business_hours",
      subject: ["administrator"],
    },
    {
      action: "settings.payments",
      subject: ["administrator"],
    },
    {
      action: "settings.labels",
      subject: ["administrator"],
    },
    {
      action: "settings.addons",
      subject: ["administrator"],
    },
    {
      action: "settings.integrations",
      subject: ["administrator"],
    },
    {
      action: "customer.list",
      subject: ["administrator", "staff"],
    },
    {
      action: "customer.add",
      subject: ["administrator", "staff"],
    },
    {
      action: "customer.edit",
      subject: ["administrator", "staff"],
    },
    {
      action: "customer.view",
      subject: ["administrator", "staff"],
    },
    {
      action: "transaction.list",
      subject: ["administrator", "staff"],
    },
    {
      action: "transaction.edit",
      subject: ["administrator", "staff"],
    },
    {
      action: "transaction.delete",
      subject: ["administrator"],
    },
    {
      action: "notification.list",
      subject: ["administrator"],
    },
    {
      action: "notification.edit",
      subject: ["administrator"],
    },
    {
      action: "activity.list",
      subject: ["administrator"],
    },
    {
      action: "logout",
      subject: ["administrator", "staff"],
    },
    {
      action: "customizer",
      subject: ["administrator"],
    },
    {
      action: "customizer.form.service",
      subject: ["administrator"],
    },
    {
      action: "customizer.form.staff",
      subject: ["administrator"],
    },
    {
      action: "customizer.form.date",
      subject: ["administrator"],
    },
    {
      action: "customizer.form.time",
      subject: ["administrator"],
    },
    {
      action: "customizer.form.account",
      subject: ["administrator"],
    },
    {
      action: "customizer.form.overview",
      subject: ["administrator"],
    },
    {
      action: "customizer.widget.general",
      subject: ["administrator"],
    },
    {
      action: "customizer.chat.banner",
      subject: ["administrator"],
    },
    {
      action: "customizer.chat.welcome",
      subject: ["administrator"],
    },
    {
      action: "customizer.chat.service",
      subject: ["administrator"],
    },
    {
      action: "customizer.chat.staff",
      subject: ["administrator"],
    },
    {
      action: "customizer.chat.date",
      subject: ["administrator"],
    },
    {
      action: "customizer.chat.time",
      subject: ["administrator"],
    },
    {
      action: "customizer.chat.account",
      subject: ["administrator"],
    },
    {
      action: "customizer.chat.overview",
      subject: ["administrator"],
    },
    {
      action: "onboarding.business.info",
      subject: ["administrator"],
    },
    {
      action: "onboarding.business.address",
      subject: ["administrator"],
    },
    {
      action: "onboarding.business.hours",
      subject: ["administrator"],
    },
    {
      action: "onboarding.service.general",
      subject: ["administrator"],
    },
    {
      action: "onboarding.service.staff",
      subject: ["administrator"],
    },
    {
      action: "onboarding.service.duration",
      subject: ["administrator"],
    },
    {
      action: "onboarding.staff.profile",
      subject: ["administrator"],
    },
    {
      action: "setup",
      subject: ["administrator", "staff"],
    },
    {
      action: "setup.type",
      subject: ["administrator", "staff"],
    },
    {
      action: "setup.info",
      subject: ["administrator", "staff"],
    },
    {
      action: "setup.availability",
      subject: ["administrator", "staff"],
    },
    {
      action: "setup.brand",
      subject: ["administrator", "staff"],
    },
    {
      action: "setup.finish",
      subject: ["administrator", "staff"],
    },
    {
      action: "chat.customizer",
      subject: ["administrator", "staff"],
    },
    // {
    //     action: "chat.customizer.banner",
    //     subject: ["administrator", "staff"]
    // },
    {
      action: "chat.customizer.widget",
      subject: ["administrator"],
    },
    {
      action: "chat.customizer.top-banner",
      subject: ["administrator"],
    },
    {
      action: "chat.customizer.welcome-title",
      subject: ["administrator"],
    },
    {
      action: "chat.customizer.service",
      subject: ["administrator"],
    },
    {
      action: "chat.customizer.staff",
      subject: ["administrator"],
    },
    {
      action: "chat.customizer.date",
      subject: ["administrator"],
    },
    {
      action: "chat.customizer.time",
      subject: ["administrator"],
    },
    {
      action: "chat.customizer.account",
      subject: ["administrator"],
    },
    {
      action: "chat.customizer.overview",
      subject: ["administrator"],
    },
  ]);

  const initPermissions = () => {
    ability.defineAbility(routePermissions.value);
    Log("init route permissions");
  };

  return {
    routePermissions,
    initPermissions,
  };
});
